import { Box, Paper, Typography } from '@mui/material';
import NotificationSnackbar, { NotificationType } from 'components/common/NotificationSnackBar';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import WebsiteFilters from '../features/websites/components/WebsiteFilters';
import WebsitesTable from '../features/websites/components/WebsitesTable';
// Fetching now lives inside WebsitesTable to prevent double fetch and remount loops
import { useLocation } from 'react-router-dom';

const WebsitesPage: React.FC = () => {
  const { error } = useSelector((state: RootState) => state.websites);
  
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    type: 'info' as NotificationType,
  });

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const openWebsiteId = searchParams.get('openWebsiteId') || undefined;
  const openTab = (searchParams.get('openTab') as 'basic' | 'content' | 'studio' | 'issuecast' | null) || undefined;

  // Intentionally do not fetch here; WebsitesTable handles fetching on mount and on publisher filter changes.

  useEffect(() => {
    if (error) {
      setNotification({
        open: true,
        message: error,
        type: 'error',
      });
    }
  }, [error]);

  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Website Management
      </Typography>
      <Typography variant="body1" paragraph>
        Manage websites that provide content to the Location Station platform. You can add new websites, edit existing ones,
        and configure their categories and associated publishers.
      </Typography>
      
      <Paper sx={{ p: 3, mb: 3 }}>
        <WebsiteFilters />
      </Paper>
      
      {/* Always render the table so it can manage its own loading UI without being unmounted by page-level loading state. */}
      <WebsitesTable openWebsiteId={openWebsiteId} openTab={openTab} />
      
      <NotificationSnackbar
        open={notification.open}
        message={notification.message}
        type={notification.type}
        onClose={closeNotification}
      />
    </Box>
  );
};

export default WebsitesPage;